import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "./app/assets/css/style.scss";
import "./app/assets/css/global-animation-ltr.scss";
import "./app/assets/css/global-animation-rtl.scss";
import "./app/assets/css/global-animation-responsive-ltr.scss";
import "./app/assets/css/global-animation-responsive-rtl.scss";
import { BrowserRouter as Router } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import i18n from "./app/Languages/INEXT";
import reportWebVitals from "./reportWebVitals";
import App from "./app/App";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";



const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <Router>
        <App />
      </Router>
    </I18nextProvider>
  </React.StrictMode>
);

reportWebVitals();
